export default __webpack_public_path__ + "static/media/PatientStatusReport.88274338.svg";